import { render } from "./search-result.vue?vue&type=template&id=22feacc8&scoped=true"
import script from "./search-result.vue?vue&type=script&lang=js"
export * from "./search-result.vue?vue&type=script&lang=js"

import "./search-result.vue?vue&type=style&index=0&id=22feacc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22feacc8"]])

export default __exports__